export default "__VITE_ASSET__DaULRsPx__"